import { useSelector } from "react-redux";
import { selectCurrentLogbook } from "../../store/features/logbooks.slice";
import LogbookDetails from "../common/logbook-details";

export default function CompanyLogbook() {
  const logbook = useSelector(selectCurrentLogbook);

  return <LogbookDetails logbook={logbook} isCurrentUserACompany />;
}
